var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('dg-layout',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('onboarding-header')]},proxy:true}])},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('dg-onboarding-box',[_c('router-view',{staticClass:"content-body"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }